import React from "react";
import AddCajaForm from "./AddCajaForm";

const AddCaja = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Caja"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddCajaForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddCaja;
